// extracted by mini-css-extract-plugin
export default {"BirthDateInput":"bfw_a big_z big_kc big_qx big_xc big_eg","BirthDateInput--disabled":"bfw_b big_fo"};